/** Normalize a raw tip_pools row to the client {@link ITipPool} shape. */
export function mapTipPoolRow(row) {
    return {
        id: row.id,
        name: row.name,
        isDefault: Boolean(row.is_default),
        splitPercent: row.split_percent === null || row.split_percent === undefined
            ? null
            : Number(row.split_percent),
    };
}
/**
 * List active (non-deleted) tip pools for a restaurant, default pool first.
 */
export async function listTipPools(client, restaurantId) {
    const { data, error } = await client
        .from("tip_pools")
        .select("id, name, is_default, split_percent")
        .eq("restaurant_id", restaurantId)
        .is("deleted_at", null)
        .order("is_default", { ascending: false });
    if (error)
        throw new Error(error.message);
    return (data ?? []).map(mapTipPoolRow);
}
